<script>
  import {mapState, mapMutations} from 'vuex';
  import PostingTogglePrototype from '@/prototypes/PostingTogglePrototype';

  export default {
    extends: PostingTogglePrototype,
    computed: {
      ...mapState('PostingStore/AutoInviteStore', {
        toggleValue: (state) => state.autoInvite
      }),
      toggleDescription() { return this.$gettext('Auto invite'); }
    },
    methods: {
      ...mapMutations({
        toggleHandler: 'PostingStore/AutoInviteStore/setAutoInvite'
      })
    }
  };
</script>
